/**
 * @file excludedFields
 *
 * @fileoverview These fields should not be displayed.
 */
export const excludedFields = [
  'revision_id',
  'parent_id',
  'parent_type',
  'parent_field_name',
  'behavior_settings',
  'created',
  'changed',
  'nid',
  'uuid',
  'vid',
  'langcode',
  'type',
  'revision_timestamp',
  'revision_uid',
  'revision_log',
  'status',
  'uid',
  'sticky',
  'default_langcode',
  'revision_default',
  'revision_translation_affected',
  'metatag',
  'path',
  'menu_link',
  'promote',
  'field_job_workflow_state',
  'roles',
  'company_profile_profiles',
  'company_base_profile_profiles',
  'customer_profiles',
  'timezone',
  'revision_log_message',
  // Dates not yet supported.
  'field_job_expiration_date',
  'field_job_publishing_date',
  // Profile fields
  'is_default',
  'field_frontend',
  // Contact form fields.
  'contact_form',
  'recipient',
  'content_translation_outdated',
];
